<div class="auth-container auth-container--tfa" [ngClass]="{ mobile: isMobile$ | async }">
  <mat-card class="auth-card">
    <img src="assets/images/t2a/google_authenticator.svg" alt="google" />
    <h1 class="mat-headline-3">{{ 'WM_TECH_POOL.TFA_VERIFY.TITLE' | translate }}</h1>

    <mat-card-content>
      <form [formGroup]="tfaForm" (ngSubmit)="verifyTfa()" class="tfa-form">
        <mat-form-field appearance="outline" [class.invalid-tfaCode]="tfaCodeRequestFailed" class="wm-input">
          <input appDigitsOnly #input matInput formControlName="tfaCode" type="text" inputmode="numeric" axAutoFocus axDigitsOnly minlength="6" maxlength="6" required />
        </mat-form-field>
      </form>

      <div class="auth-links">
        <a (click)="logOut()">{{ 'WM_TECH.AUTH.LOGOUT' | translate }}</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
